import Tween from './Tween';
export { default as Easing } from './easing';
export default Tween;